import { render, staticRenderFns } from "./AvailabilityStatusBadge.vue?vue&type=template&id=f2066c94&scoped=true&"
import script from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityStatusBadge.vue?vue&type=style&index=0&id=f2066c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2066c94",
  null
  
)

export default component.exports